export default from './IdNameActiveEntity';



// WEBPACK FOOTER //
// ./shared/src/entity/AgencyEntity.js